// extracted by mini-css-extract-plugin
export var btn = "twoBlocks-module--btn--2gyCW";
export var card = "twoBlocks-module--card--iPpO+";
export var card1 = "twoBlocks-module--card1--c2vOw";
export var card2 = "twoBlocks-module--card2--rwh7c";
export var cardList = "twoBlocks-module--cardList--DUYuG";
export var container = "twoBlocks-module--container--Os-1V";
export var description = "twoBlocks-module--description--b3rw2";
export var headTitle = "twoBlocks-module--headTitle--VrlfU";
export var img = "twoBlocks-module--img--Sorg+";
export var secondary = "twoBlocks-module--secondary--x9XMQ";
export var textBlock = "twoBlocks-module--textBlock--NsZYc";
export var title = "twoBlocks-module--title--0Q8vg";